import { IQuery, PaginationDto } from '@zaplify/common';
import { Topics } from '@zaplify/common';
import { UserDto } from '../users/user.dto';

export class GetUsersActiveAfterQuery extends IQuery<PaginationDto<UserDto>> {
    public static override readonly TOPIC = Topics.USERS;

    constructor(
        readonly query: {
            lastActiveAfter: Date;
            limit: number;
            page: number;
        },
    ) {
        super();
    }
}
